import React, { useContext, useEffect, useState } from 'react';
import PropTypes from "prop-types";
import socket from "socket.io-client";
import { logoutContext,Notifcations } from './App';
import cookie from 'react-cookies'
import { Redirect } from 'react-router';

let LOGOUT_FLAG = false

const Sockt = ({ serverUrl, id, Logouttopic, Notifytopic, logOutFn }) => {

    const { handleLogOutSocket } = useContext(logoutContext)
    const { handelNotificationCount } = useContext(Notifcations)
    const [count, setCount] = React.useState(0);
    const [prevcount, setprevCount] = React.useState(0);
    const [isConnected, setConnected] = React.useState(false);
    const [flagCall, setFlagCall] = React.useState(true);
    const [logOutRedirect, setRedirectLogout] = useState(false);
    let test=0
    const client = socket.connect(serverUrl, {
        query: {
            id: id
        }
    });

    useEffect(() => {
        client.on(Logouttopic, data => {
            console.log("Socket take place Logout", data)
            // setLogout(data.newUser);
            if ((data.newUser&&data.newUser.activated === false)||(data.user&&data.user.deleted) ) {
                LOGOUT_FLAG = true;
                handleLogOutSocket(true)
                cookie.remove('HBUser', { path: '/' })
                cookie.remove('HB_token', { path: '/' })
                sessionStorage.removeItem("HBUser");
                sessionStorage.removeItem("HB_token");
                console.log('sasasa==> ', cookie.load("HBUser"))
                setRedirectLogout(true)
            }
        });
        client.on(Notifytopic, data => {
            test=prevcount
            console.log("Socket take place Notification",prevcount, data.count,test)
            
            if (test !== data.count) {
                test=data.count
                console.log("Socket take place Notification in cond", data)
                handelNotificationCount(data.count)
                setCount(data.count)
                setprevCount(data.count)
            }
        });
    }, [Logouttopic, client]);

    if (flagCall) {
        setFlagCall(false)
        client.on("connect", () => setConnected(true));
    }
    console.log("flag logout from socket io==> ")
    return (
        <div>
        </div>
    );
};

Sockt.propTypes = {
    serverUrl: PropTypes.string.isRequired,
    topic: PropTypes.string.isRequired
};

export default Sockt;
